import axios from 'axios';
import qs from 'qs';
import { get } from 'lodash';

const OUTGOINGSMS_LIST_LOAD = 'OUTGOINGSMS_LIST_LOAD';
const OUTGOINGSMS_LIST_SUCCESS = 'OUTGOINGSMS_LIST_SUCCESS';
const OUTGOINGSMS_LIST_FAILED = 'OUTGOINGSMS_LIST_FAILED';
const OUTGOINGSMS_SET_LOADING = 'OUTGOINGSMS_SET_LOADING';

const OUTGOINGSMS_FORM_LOAD = 'OUTGOINGSMS_FORM_LOAD';
const OUTGOINGSMS_FORM_SUCCESS = 'OUTGOINGSMS_FORM_SUCCESS';
const OUTGOINGSMS_FORM_FAILED = 'OUTGOINGSMS_FORM_FAILED';

const OUTGOINGSMS_DELETE_LOAD = 'OUTGOINGSMS_DELETE_LOAD';
const OUTGOINGSMS_DELETE_SUCCESS = 'OUTGOINGSMS_DELETE_SUCCESS';
const OUTGOINGSMS_DELETE_FAILED = 'OUTGOINGSMS_DELETE_FAILED';

const OUTGOINGSMS_EDIT_LOAD = 'OUTGOINGSMS_EDIT_LOAD';
const OUTGOINGSMS_EDIT_SUCCESS = 'OUTGOINGSMS_EDIT_SUCCESS';
const OUTGOINGSMS_EDIT_FAILED = 'OUTGOINGSMS_EDIT_FAILED';

const OUTGOINGSMS_VIEW_LOAD = 'OUTGOINGSMS_VIEW_LOAD';
const OUTGOINGSMS_VIEW_SUCCESS = 'OUTGOINGSMS_VIEW_SUCCESS';
const OUTGOINGSMS_VIEW_FAILED = 'OUTGOINGSMS_VIEW_FAILED';

const OUTGOINGSMS_RESET = 'OUTGOINGSMS_RESET';

const initialState = {
  loading: false,
  success: false,
  saved: false,
  failed: false,
  data: [],
  message: null,
  total: 0,
  limit:process.env.REACT_APP_LIST_LIMIT,
  page: null,
  order: '',
  orderMode: 'ASC',
  deleted: false,
  deletedId: null,
  formErrors: {},
  viewData: null,
  viewLoading: false,
  commentThread: false,
  id: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case OUTGOINGSMS_RESET:
      return {
        ...initialState
      };
    case OUTGOINGSMS_DELETE_LOAD:
      return {
        ...state,
        deleted: false,
        deletedId: null,
        viewLoading: false
      };
    case OUTGOINGSMS_LIST_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        viewLoading: false
      };
    case OUTGOINGSMS_EDIT_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: false
      };
    case OUTGOINGSMS_VIEW_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: true
      };
    case OUTGOINGSMS_FORM_LOAD:
      return {
        ...state,
        loading: false,
        failed: false,
        message: null,
        viewLoading: false
      };
    case OUTGOINGSMS_FORM_FAILED:
    case OUTGOINGSMS_EDIT_FAILED:
    case OUTGOINGSMS_DELETE_FAILED:
    case OUTGOINGSMS_LIST_FAILED:
    case OUTGOINGSMS_VIEW_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        saved: false,
        failed: true,
        message: action.message,
        formErrors: action.formErrors || {},
        deleted: true,
        deletedId: null,
        viewLoading: false
      };
    case OUTGOINGSMS_LIST_SUCCESS:
      return {
        ...state,
        success: true,
        failed: false,
        data: action.data,
        total: action.total,
        limit: action.limit,
        page: action.page,
        order: action.order,
        orderMode: action.orderMode
      };
      case OUTGOINGSMS_VIEW_SUCCESS:
        return {
            ...state,
            loading: false,
            success: true,
            failed: false,
            viewData: action.viewData,
            viewLoading: false
        };
    case OUTGOINGSMS_FORM_SUCCESS:
      return {
        ...state,
        fields: action.fields,
        loading: false,
        success: true,
        failed: false,
        viewLoading: false
      };
    case OUTGOINGSMS_DELETE_SUCCESS:
      return {
        ...state,
        deleted: true,
        deletedId: action.id
      };
    case OUTGOINGSMS_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        saved: true,
        failed: false,
        message: null,
        formErrors: {},
        id: action.id,
        viewLoading: false
      };
    case OUTGOINGSMS_SET_LOADING:
      return {
        ...state,
        loading: action.loading,
        viewLoading: false
      };
    default:
      return state;
  }
}

export const reset = () => dispatch => {
  dispatch({
    type: OUTGOINGSMS_RESET
  });
};

export const updateOutgoingSms = (model,id,data) => dispatch => {
  dispatch({
    type: OUTGOINGSMS_EDIT_LOAD
  });

    let obj = {};
    obj[model] = data;

  return axios.put('/v1/outgoing-sms-messages/'+id, obj).then(
      () => dispatch({
        type: OUTGOINGSMS_EDIT_SUCCESS
      })
  ).catch(error => {
    dispatch({
      type: OUTGOINGSMS_EDIT_FAILED,
      message: get(error, 'response.data.message', null),
      formErrors: get(error, 'response.data.form_errors', {})
    })
  });
};

export const viewOutgoingSms = (id) => dispatch => {
    dispatch({
        type: OUTGOINGSMS_VIEW_LOAD
    });
    return axios.get('/v1/outgoing-sms-messages/'+id).then(
        response => dispatch({
            type: OUTGOINGSMS_VIEW_SUCCESS,
            viewData: get(response, 'data.data'),
            commentThread: get(response, 'data.commentThread', false)
        })
    ).catch(error => {
        dispatch({
            type: OUTGOINGSMS_VIEW_FAILED,
            message: get(error, 'response.data.message', null)
        })
    });
};

export const createOutgoingSms = (model, data) => dispatch => {
  dispatch({
    type: OUTGOINGSMS_EDIT_LOAD
  });

  let obj = {};
  obj[model] = data;

  return axios.post('/v1/outgoing-sms-messages', obj).then(response => dispatch({
    type: OUTGOINGSMS_EDIT_SUCCESS,
    id: get(response, 'data.data.id', null),
  })).catch(error => {
    dispatch({
      type: OUTGOINGSMS_EDIT_FAILED,
      message: get(error, 'response.data.message', null),
      formErrors: get(error, 'response.data.form_errors', {})
    })
  });
};

export const OutgoingSmsDelete = (id) => dispatch => {
  dispatch({
    type: OUTGOINGSMS_DELETE_LOAD
  });
  return axios.delete('/v1/outgoing-sms-messages/'+id)
      .then((response) => dispatch({
        type: OUTGOINGSMS_DELETE_SUCCESS,
        id
      })).catch(error => dispatch({
        type: OUTGOINGSMS_DELETE_FAILED,
        message: get(error, 'response.data.message', null)
      }));
};

export const setLoading = (loading) => dispatch => {
  dispatch({
    type: OUTGOINGSMS_SET_LOADING,
    loading
  });
};

export const OutgoingSmsList = (page, keyword, sort, filters, perPage) => dispatch => {
  dispatch({
    type: OUTGOINGSMS_LIST_LOAD
  });

  let params = {
    page,
    keyword,
    sort,
    'per-page': perPage
  };

  params[filters.model] = filters.filters;

  return axios.get(
      '/v1/outgoing-sms-messages',
      {
        params: params,
        paramsSerializer: function(params) {
          return qs.stringify(params, { encode: false });
        }
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
  ).then(response => {
    let sort = get(response, 'data.sort', null),
        mode = 'ASC';
    if(sort && sort.indexOf('-') !== -1) {
      mode = 'DESC';
      sort = sort.substr(1);
    }
    return dispatch({
      type: OUTGOINGSMS_LIST_SUCCESS,
      data: get(response, 'data.data', null),
      page: get(response, 'data.page', 0),
      limit: get(response, 'data.per-page', 0),
      total: get(response, 'data.total', 0),
      order: sort,
      orderMode: mode
    });
  })
  .catch(error => dispatch({
    type: OUTGOINGSMS_LIST_FAILED,
    message: get(error, 'response.data.message', null)
  }));
};



// WEBPACK FOOTER //
// ./src/redux/modules/outgoing-sms.js